import autoLwopService from "./auto-lwop.service";
import leaveService from "./leave.service";
import metricsService from "./metrics.service";
import timesheetService from "./timesheet.service";

export default angular.module('app.pages.timesheet.services', [
  autoLwopService.name,leaveService.name,metricsService.name,timesheetService.name
]);



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/services.js